var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-button"},[_c('bac-router-link-or-a',{staticClass:"uk-first-column",attrs:{"href":_vm.buttonLink,"routerLink":!_vm.button.link.startsWith('http'),"target":_vm.button.target,"title":_vm.button.name}},[_c('img',{attrs:{"src":_vm.imageLink,"alt":_vm.button.name}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }